var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "NAVOnlineInvoiceInterfaceSettings",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  attrs: {
                    name: _vm.formName,
                    readonly: _vm.resource.locked,
                    labelAlign: _vm.$config.forms.defaultLabelAlign,
                    id: _vm.formId
                  },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpRow",
                    [
                      _c(
                        "ItpCol",
                        [
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "company_name",
                                label: _vm._f("pgettext")(
                                  "Company name",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "font-weight-bold no-focus-border",
                                attrs: { plaintext: "" },
                                model: {
                                  value: _vm.editor.company_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "company_name", $$v)
                                  },
                                  expression: "editor.company_name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "base_url",
                                label: _vm._f("pgettext")(
                                  "Base URL",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The root URL of the service.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "base_url", required: "" },
                                model: {
                                  value: _vm.editor.base_url,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "base_url", $$v)
                                  },
                                  expression: "editor.base_url"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "tax_number",
                                label: _vm._f("pgettext")(
                                  "Tax number",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                required: "",
                                helpTooltip: _vm._f("pgettext")(
                                  "The first 8 digits of the tax number.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "tax_number", required: "" },
                                model: {
                                  value: _vm.editor.tax_number,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "tax_number", $$v)
                                  },
                                  expression: "editor.tax_number"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "login",
                                label: _vm._f("pgettext")(
                                  "Login",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The technical user's login name.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "login", required: "" },
                                model: {
                                  value: _vm.editor.login,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "login", $$v)
                                  },
                                  expression: "editor.login"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("HR"),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "password_hash",
                                label: _vm._f("pgettext")(
                                  "Password hash",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The generated password's SHA-512 hash.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormTextarea", {
                                attrs: { name: "password_hash", readonly: "" },
                                model: {
                                  value: _vm.resource.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.resource, "password", $$v)
                                  },
                                  expression: "resource.password"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "password",
                                label: _vm._f("pgettext")(
                                  "Password",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The generated password.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { type: "password", name: "password" },
                                model: {
                                  value: _vm.change_password.password,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.change_password,
                                      "password",
                                      $$v
                                    )
                                  },
                                  expression: "change_password.password"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "password",
                                label: _vm._f("pgettext")(
                                  "Confirm password",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The generated password.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  type: "password",
                                  name: "verify_password"
                                },
                                model: {
                                  value: _vm.change_password.verify_password,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.change_password,
                                      "verify_password",
                                      $$v
                                    )
                                  },
                                  expression: "change_password.verify_password"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("HR"),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "xml_sign_key",
                                label: _vm._f("pgettext")(
                                  "XML sign key",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The technical user's XML sign key.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "xml_sign_key", required: "" },
                                model: {
                                  value: _vm.editor.xml_sign_key,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "xml_sign_key", $$v)
                                  },
                                  expression: "editor.xml_sign_key"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "exchange_key",
                                label: _vm._f("pgettext")(
                                  "XML exchange key",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The technical user's XML exchange key.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "exchange_key", required: "" },
                                model: {
                                  value: _vm.editor.exchange_key,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "exchange_key", $$v)
                                  },
                                  expression: "editor.exchange_key"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "add_unknown_clients",
                                label: _vm._f("pgettext")(
                                  "Save unknown clients.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "Add unknown client to the database.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: { name: "add_unknown_clients" },
                                model: {
                                  value: _vm.editor.add_unknown_clients,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editor,
                                      "add_unknown_clients",
                                      $$v
                                    )
                                  },
                                  expression: "editor.add_unknown_clients"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "2",
                                name: "lookback_period",
                                label: _vm._f("pgettext")(
                                  "Lookback period",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The number of days to be used to look back for invoices.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                contentClass: "input-group"
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  type: "number",
                                  name: "lookback_period"
                                },
                                model: {
                                  value: _vm.editor.lookback_period,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "lookback_period", $$v)
                                  },
                                  expression: "editor.lookback_period"
                                }
                              }),
                              _vm._v(" "),
                              _c("DIV", { staticClass: "input-group-append" }, [
                                _c(
                                  "span",
                                  { staticClass: "input-group-text" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("pgettext")(
                                            "days",
                                            "InputGroupAddon"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "2",
                                name: "request_timeout",
                                label: _vm._f("pgettext")(
                                  "Request timeout",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "Stop waiting for a response once the specified timeout has expired.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                contentClass: "input-group"
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  type: "number",
                                  name: "request_timeout"
                                },
                                model: {
                                  value: _vm.editor.request_timeout,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "request_timeout", $$v)
                                  },
                                  expression: "editor.request_timeout"
                                }
                              }),
                              _vm._v(" "),
                              _c("DIV", { staticClass: "input-group-append" }, [
                                _c(
                                  "span",
                                  { staticClass: "input-group-text" },
                                  [
                                    _vm._v(
                                      "\n                sec\n              "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "auto_sync",
                                label: _vm._f("pgettext")(
                                  "Auto sync",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "Check to include this company to the automated sync job.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: { name: "auto_sync" },
                                model: {
                                  value: _vm.editor.auto_sync,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "auto_sync", $$v)
                                  },
                                  expression: "editor.auto_sync"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "pull_incoming_invoices",
                                label: _vm._f("pgettext")(
                                  "Pull incoming invoices",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "Enable pulling of incoming invoices from the agency.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: { name: "pull_incoming_invoices" },
                                model: {
                                  value: _vm.editor.pull_incoming_invoices,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editor,
                                      "pull_incoming_invoices",
                                      $$v
                                    )
                                  },
                                  expression: "editor.pull_incoming_invoices"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "pull_outgoing_invoices",
                                label: _vm._f("pgettext")(
                                  "Pull outgoing invoices",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "Enable pulling of outgoing invoices from the agency.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: { name: "pull_outgoing_invoices" },
                                model: {
                                  value: _vm.editor.pull_outgoing_invoices,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editor,
                                      "pull_outgoing_invoices",
                                      $$v
                                    )
                                  },
                                  expression: "editor.pull_outgoing_invoices"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "invoice_tag",
                                label: _vm._f("pgettext")(
                                  "Invoice tag",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                helpTooltip: _vm._f("pgettext")(
                                  "The tag to set on the imported invoices.",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "invoice_tag" },
                                model: {
                                  value: _vm.editor.invoice_tag,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "invoice_tag", $$v)
                                  },
                                  expression: "editor.invoice_tag"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  form: _vm.forms[_vm.formName] && _vm.forms[_vm.formName].id,
                  text: _vm._f("pgettext")("Save", "Button"),
                  type: "submit",
                  variant: "primary",
                  default: "",
                  spinning: _vm.actions.submit && _vm.actions.submit.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Close", "Button"),
                  variant: "default",
                  disabled: _vm.actions.submit && _vm.actions.submit.isRunning
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }